import React from 'react';
import { isValidPhoneNumber } from 'react-phone-number-input';
// We have to import from the /input subdirectory because the
// the main module component includes a country flag selector
// that we don't include in our product.
import PhoneInput from 'react-phone-number-input/input';
import 'react-phone-number-input/style.css';

import {
  BaseTextField,
  BaseTextFieldProps,
} from 'src/legacy/components/TextField';

const PhoneInputRef = React.forwardRef((props, ref) => (
  <BaseTextField
    inputRef={ref}
    fullWidth
    id="phone"
    type="text"
    key="phone"
    name="phone"
    variant="outlined"
    {...props}
  />
));

const getPhoneError = (value: string) => {
  if (!value) {
    return 'Phone number required';
  }

  try {
    if (isValidPhoneNumber(value)) {
      return undefined;
    }
  } catch (ex) {
    console.error('Phone validation error', ex);
  }

  return 'Invalid phone number';
};

type PhoneNumberInputProps = Omit<
  BaseTextFieldProps,
  'onChange' | 'onBlur' | 'value'
> & {
  value: string;
  touched?: boolean;
  onChange: (value: string) => void;
  onBlur?: (() => void) | React.FocusEventHandler<HTMLInputElement>;
};

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  touched,
  onChange,
  onBlur,
  error: _error,
  ...other
}) => {
  const errorMessage = getPhoneError(value);

  return (
    <PhoneInput
      defaultCountry="US"
      onChange={onChange}
      value={value}
      onBlur={() => {
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
        if (onBlur) {
          (onBlur as () => void)();
        }
      }}
      error={touched && errorMessage ? errorMessage : undefined}
      inputComponent={PhoneInputRef}
      {...(other as Record<string, unknown>)}
    />
  );
};

export default PhoneNumberInput;
